import { Controller } from 'libraries/front-end-core/core/Router'
import url from 'libraries/front-end-core/core/url'
import { DOCUMENTS_CONTENT } from 'constants/controllers'
import Main from './Main'

export default new Controller({
  name: DOCUMENTS_CONTENT,
  route: 'documents/:aol/:sectionId(/:focusedId)',
  controller (Router, { params: { aol, sectionId, focusedId } }, render) {
    const pageId = url(
      DOCUMENTS_CONTENT,
      { aol, focusedId, sectionId }
    )

    render(
      { Main },
      {
        sectionId,
        focusedId,
        aol,
        pageId
      },
      {
        searchType: 'precedents',
        className: 'precedents',
        pageId,
        aol
      }
    )

    return pageId
  }
})
